import { registerPlugin } from '@capacitor/core'

export interface HttpPlugin {
  requestPromise(options: {
    url: string
    method?: string
    headers?: Record<string, string>
    body?: string
    bodyType?: 'json' | 'form' | 'text' | 'multipart'
  }): Promise<{
    status: number
    statusText: string
    headers: Record<string, string>
    data: any
  }>
}

const Http = registerPlugin<HttpPlugin>('Http', {
  web: {
    // En web, usar fetch normal (no podemos ignorar certificados por seguridad)
    requestPromise: async (options: {
      url: string
      method?: string
      headers?: Record<string, string>
      body?: string
      bodyType?: 'json' | 'form' | 'text' | 'multipart'
    }) => {
      const response = await fetch(options.url, {
        method: options.method || 'GET',
        headers: options.headers || {},
        body: options.body,
      })

      const data = await response.json().catch(() => response.text())

      const headers: Record<string, string> = {}
      response.headers.forEach((value, key) => {
        headers[key] = value
      })

      return {
        status: response.status,
        statusText: response.statusText,
        headers,
        data,
      }
    },
  },
})

export default Http
